import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthRoute = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  if (isAuthenticated) {
    // Redirect to appropriate dashboard based on user role
    switch (user?.role) {
      case 'student':
        return <Navigate to="/student-dashboard" replace />;
      case 'trainer':
        return <Navigate to="/trainer-dashboard" replace />;
      case 'counselor':
        return <Navigate to="/counselor-dashboard" replace />;
      default:
        return <Navigate to={from} replace />;
    }
  }

  return <Outlet />;
};

export default AuthRoute; 